import { PageAlertActionTypes } from "../constants";

interface ShowPageAlertAction {
  type: "SHOW_PAGE_ALERT";

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  payload: Record<string, any>;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const showPageAlert = (data: Record<string, any>): ShowPageAlertAction => {
  return {
    type: PageAlertActionTypes.SHOW_PAGE_ALERT,
    payload: data,
  };
};

interface HidePageAlertAction {
  type: "HIDE_PAGE_ALERT";
}

export const hidePageAlert = (): HidePageAlertAction => {
  return {
    type: PageAlertActionTypes.HIDE_PAGE_ALERT,
  };
};

export type Action = ShowPageAlertAction | HidePageAlertAction;
